// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2729":"6abe275f","4095":"7f97dede"}[chunkId] + ".chunk.css";
};